import React from 'react';
import { useForm } from 'react-hook-form';
import { injectIntl } from '../../utils/reactIntl';
import {
  Button,
  FieldCheckbox,
} from '../../components';
import './reportexport.global.scss';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  intl: any;
  handleFormSubmit: any,
  handleCloseModal: any,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const ExportReportForm: React.FC<Props> = (props: Props) => {
  const {
    intl,
    handleFormSubmit,
    handleCloseModal,
  } = props;
  const formProps = useForm();

  return (
    <form className="filterForm" onSubmit={formProps.handleSubmit(handleFormSubmit)}>
      <FieldCheckbox
        id="user-reported-event"
        name="user-reported-event"
        formProps={formProps}
        className="radioColumn"
        label="Event Reported"
      />
      <FieldCheckbox
        id="user-reported"
        name="user-reported"
        formProps={formProps}
        className="radioColumn"
        label="User Reported"
      />
      <FieldCheckbox
        id="channel-reported"
        name="channel-reported"
        formProps={formProps}
        className="radioColumn"
        label="Channel Reported"
      />
      <FieldCheckbox
        id="post-reported"
        name="post-reported"
        formProps={formProps}
        className="radioColumn"
        label="Post Reported"
      />
      <FieldCheckbox
        id="notification-reported"
        name="notification-reported"
        formProps={formProps}
        className="radioColumn"
        label="Notification"
      />
      <FieldCheckbox
        id="notes"
        name="notes"
        formProps={formProps}
        className="radioColumn"
        label="Notes"
      />
      <div className="buttonWrapper">
        <Button
          onClick={handleCloseModal}
        >
          {intl.formatMessage({ id: 'ExportUserInfo.button.cancel' })}
        </Button>
        <Button
          buttonType={ButtonTypes.submit}
        >
          {intl.formatMessage({ id: 'ExportUserInfo.button.export' })}
        </Button>
      </div>
    </form>
  );
};

export default injectIntl(ExportReportForm);
